import { render, staticRenderFns } from "./qua.vue?vue&type=template&id=495a9b4c&scoped=true&"
import script from "./qua.vue?vue&type=script&lang=js&"
export * from "./qua.vue?vue&type=script&lang=js&"
import style0 from "./qua.vue?vue&type=style&index=0&id=495a9b4c&scoped=true&lang=less&"
import style1 from "./qua.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495a9b4c",
  null
  
)

export default component.exports